const dataNS = '_mduiElementDataStorage';
export default dataNS;
